import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../actions/lms-profiles.action'
import lmsProfilesList from 'api/lms-profiles/List'

async function getList(page: number, searchText: string, sort: any[]) {
  return await lmsProfilesList(page, searchText, sort)
}

function* lmsProfilesListEffectSaga(action: any) {
  try {
    const { page, searchText, sort } = action.payload
    const list = yield call(getList, page, searchText, sort)
    let { data } = list
    const { total, perPage } = list
    const pages = Math.ceil(total / perPage)
    for (let i = 2; i <= pages; i++) {
      const { data: next } = yield call(getList, i, searchText, sort)
      data = [...data, ...next]
    }
    yield put(
      fromActions.Actions.lmsProfilesListSuccess(data, total, perPage, sort)
    )
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* lmsProfilesListWatcherSaga() {
  yield takeLatest(fromActions.LMS_PROFILES_LIST_GET, lmsProfilesListEffectSaga)
}
